import dayjs from "dayjs";

const PACKAGE_CAR_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";
const PACKAGE_DATE_FORMAT = "YYYY-MM-DD";

/**
 * Formats pickup and dropoff dates for package car availability requests.
 * Normalizes times to noon (12:00) for consistent API usage across the package flow.
 */
export const useFormatPackagePickupDropoffDates = (
  fromDate: string,
  untilDate: string
): { pickupDate: string; dropoffDate: string } => {
  return {
    pickupDate: dayjs(fromDate).hour(12).format(PACKAGE_CAR_DATETIME_FORMAT),
    dropoffDate: dayjs(untilDate).hour(12).format(PACKAGE_CAR_DATETIME_FORMAT),
  };
};

export const formatPackageDynamicFieldDates = (
  fromDate: string,
  untilDate: string
): { startDate: string; endDate: string } => {
  return {
    startDate: dayjs(fromDate).format(PACKAGE_DATE_FORMAT),
    endDate: dayjs(untilDate).format(PACKAGE_DATE_FORMAT),
  };
};

export const formatPackagePickupDropoffDatesFromBenchmark = (
  fromDate: string,
  untilDate: string
): { pickupDate: string; dropoffDate: string } => {
  return {
    pickupDate: dayjs(fromDate).format(PACKAGE_CAR_DATETIME_FORMAT),
    dropoffDate: dayjs(untilDate).format(PACKAGE_CAR_DATETIME_FORMAT),
  };
};
